import { ReducerCreators } from '@reduxjs/toolkit';
import { Optional } from '../../shared-kernel';
import {
  eaptekaApiRequestPromocodePost,
  eaptekaApiRequestPromocodeDelete
} from '../../services/eaptekaApi';
import { LS_PROMOCODE_APPLIED } from '../../consts';
import { Promocode, PromocodeStoreState } from './types';
import {
  PromocodeAppliedSuccess,
  PromocodeAppliedFailed
} from '../../services/dispatchers';
import { StoreError } from '../types';

const asyncThunkConfig = {
  pending: (state: PromocodeStoreState) => {
    state.loading = 'pending';
  },
  rejected: (
    state: PromocodeStoreState,
    { error }: { error: StoreError }
  ) => {
    state.loading = 'failed';
    state.error = error;
  }
};

export default (
  create: ReducerCreators<PromocodeStoreState>
) => ({
  updatePromocode: create.reducer<Optional<Promocode>>(
    (state, { payload }) => {
      if (
        payload?.status === true &&
        (state.entity === null ||
          state.entity.status === false)
      ) {
        if (
          state.entity?.notificationTitle !==
            payload?.notificationTitle ||
          state.entity?.notificationText !==
            payload?.notificationText
        ) {
          document.dispatchEvent(
            new CustomEvent('appNotificationsPushItem', {
              detail: {
                title: payload.notificationTitle,
                message: payload.notificationText
              }
            })
          );
        }

        PromocodeAppliedSuccess.dispatch(payload);
      }

      state.entity = payload;
      state.loading = 'succeeded';
    }
  ),
  applyPromocode: create.asyncThunk<void, string>(
    async (promocode, thunkApi) => {
      try {
        await eaptekaApiRequestPromocodePost({
          promoCode: promocode
        });

        localStorage.setItem(
          LS_PROMOCODE_APPLIED,
          promocode
        );
      } catch (error) {
        PromocodeAppliedFailed.dispatch(promocode);

        throw thunkApi.rejectWithValue({
          message: error.message
        });
      }
    },
    asyncThunkConfig
  ),
  removePromocode: create.asyncThunk(
    async (_, thunkApi) => {
      try {
        await eaptekaApiRequestPromocodeDelete();

        localStorage.removeItem(LS_PROMOCODE_APPLIED);
      } catch (error) {
        throw thunkApi.rejectWithValue({
          message: error.message
        });
      }
    },
    asyncThunkConfig
  )
});
